import React from "react";
import { Card, Input, Row, Col, Divider, Select } from "antd";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
const { Option } = Select;
const DropdownComponent = ({ subTotal, invoiceData, grandTotal }) => {
  const formatRoundedIndianNumber = (number) => {
    const roundedNumber = Math.round(number || 0);
    return formatIndianNumber(roundedNumber);
  };
  // Dropdown content
  return (
    <Card className="grandTotal-card">
      {/* <Row>
        <Col span={12}>Municipal Tax</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={invoiceData?.municipalTax}
            style={{ width: "4rem" }}
            controls={false}
            readOnly
          />
          &nbsp;%
        </Col>
      </Row>
      <Row>
        <Col span={12}>Others</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={invoiceData?.otherTaxes}
            style={{ width: "4rem" }}
            controls={false}
          />
          &nbsp;%
        </Col>
      </Row>

      <Row>
        <Col span={12}>+Round</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={invoiceData?.round}
            style={{ width: "4rem" }}
            controls={false}
            readOnly
          />
          &nbsp;%
        </Col>
      </Row> */}

      <Row>
        <Col span={12}>Subtotal</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatRoundedIndianNumber(subTotal)}
        </Col>
      </Row>
      <Divider />
      {/* <Row>
        <Col span={12}>GST</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatRoundedIndianNumber((subTotal * invoiceData?.IGST) / 100)}
        </Col>
      </Row> */}
      <Row>
        <Col span={8}>+IGST</Col>
        <Col span={8}>
          <Select
            // className="custom-select-bdf"
            value={Number(invoiceData?.IGST)}
            defaultValue={0}
            disabled
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={5}>5</Option>
            <Option value={18}>18</Option>
            <Option value={28}>28</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * invoiceData?.IGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+SGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(invoiceData?.SGST)}
            defaultValue={0}
            disabled
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * invoiceData?.SGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+CGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(invoiceData?.CGST)}
            defaultValue={0}
            disabled
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * invoiceData?.CGST) / 100)}
        </Col>
      </Row>
      {/* <Divider />

      <Row>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="agencyComm-span">(+/-) Agency Comm</span>
            <Input
              min={0}
              value={invoiceData?.agencyCommission}
              style={{ marginLeft: "1.3rem" }}
              controls={false}
              readOnly
            />
            &nbsp;%
          </div>
        </Col>

        <Col span={12} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber(
            (subTotal * invoiceData?.agencyCommission) / 100
          )}
        </Col>
      </Row> */}

      <Divider />
      <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
        <Col span={12}>Grand Total</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber(grandTotal)}
        </Col>
      </Row>
    </Card>
  );
};

export default DropdownComponent;
